<template>
  <div>
    <div class="flex items-center justify-between">
      <div class="flex flex-col">
        <div class="text-28 leading-36 font-bold mb-4">Diğer Tarot Okumaları</div>
        <p class="text-14 leading-20 font-medium mb-12">
          Tarot kartlarıyla hayatınızın sırlarını keşfedin! Rehberliğimiz, gelecekteki olasılıkları anlamanıza yardımcı olacak.
        </p>
      </div>
      <div v-if="!isMobile" class="flex items-center gap-3">
        <ORawIcon
          ref="prevNavBtn"
          icon="homepage/arrow-circle-right"
          svg-class="
        w-12
        h-12
        z-1
        cursor-pointer
        rotate-180
        text-xl"
        />
        <ORawIcon
          ref="nextNavBtn"
          icon="homepage/arrow-circle-right"
          svg-class="
        w-12
        h-12
        z-1
        cursor-pointer
        text-xl"
        />
      </div>
    </div>

    <Swiper v-if="!isMobile" :settings="settings" :modules="[Navigation]">
      <SwiperSlide v-for="(card, index) in tarotReadingCards" :key="index">
        <TarotReadingCard :reading-card="card" />
      </SwiperSlide>
    </Swiper>
    <div v-else class="flex flex-col gap-6">
      <TarotReadingCard v-for="(card, index) in tarotReadingCards" :key="index" :reading-card="card" />
    </div>
  </div>
</template>

<script>
import TarotReadingCard from '@/modules/tarot/components/TarotReadingCard';
import Swiper from '@/modules/sliders/core/Swiper';
import SwiperSlide from '@/modules/sliders/core/SwiperSlide';
import { defineComponent, ref } from '@nuxtjs/composition-api';
import { Navigation } from 'swiper';
import { tarotReadingCards } from '../utils/tarotUtils';
import { ORawIcon } from '~/modules/common/components/ui';
import { useDevice } from '~/composables/useDevice';

export default defineComponent({
  components: {
    TarotReadingCard,
    Swiper,
    SwiperSlide,
    ORawIcon,
  },
  setup() {
    const { isMobile } = useDevice();
    const nextNavBtn = ref(null);
    const prevNavBtn = ref(null);

    const settings = {
      slidesPerView: 2.13,
      loop: true,
      loopAdditionalSlides: 4,
      initialSlide: 0,
      navigation: {
        nextEl: nextNavBtn,
        prevEl: prevNavBtn,
      },
    };

    return { tarotReadingCards, settings, Navigation, nextNavBtn, prevNavBtn, isMobile };
  },
});
</script>
